<template>
  <header :class="{ 'mb-4': $store.state.fsNumber !== 0 }">
    <div class="top-bar">
      <div class="container px-0">
        <nav class="navbar navbar-expand-sm navbar-light d-block py-4 px-5">
          <router-link to="/" class="navbar-brand py-2"
            ><img src="assets/img/logo.png"
          /></router-link>
          <p class="float-right mb-0">European Maritime Safety Agency</p>
        </nav>
      </div>
    </div>
    <div class="sub-header-bar">
      <img class="d-block mx-auto" src="assets/img/fascia_header.png" />
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped></style>
